/**
 * Lazy load various elements (images, containers with backgrounds) based on their position on screen
 *
 * Example:
 * <img data-src="a.jpg" class="inview" data=id="uniqeid" />
 */
App.namespace.wrap('es6.shared.in_view', function () {
  const inViewTestFunction = App.es6.shared.in_view_test_function;

  function reachedView (el) {
    const src = (el.attributes['data-src'] || {}).value;

    App.es6.shared.raf(() => {
      el.classList.add('inview--loaded'); //indicate that element is loaded
    });

    if (src) {
      App.es6.shared.raf(() => {
        el.onload = function () {
          el.classList.remove('loaded-image'); //homepage
          el.parentNode.classList.remove('loading-spinner'); //homepage
        };
        el.src = src;
      }); //if it's an image switch data-src -> src
    } else if (!el.src) {
      const displayStyle = el.attributes['data-display'] || 'block';
      App.es6.shared.raf(() => el.style.display = displayStyle); //if it's not an image show the node
    }
  }

  //initiate if element is less than 500px outside the viewport
  inView.offset(-500);

  inView.test(inViewTestFunction);

  //initiate in-view by unique id
  $('.inview').each(function () {
    const selector = $(this).data('id')
      ? `.inview[data-id='${$(this).data('id')}']`
      : `.inview[data-src='${$(this).data('src')}']`;

    inView(selector).once('enter', reachedView);
  });
});
